<template>
  <div class="w-full h-5/6 flex flex-row justify-center items-center">
    <h1 class="text-light text-2xl">
      Validating Successful Order
    </h1>
    <xn-waiting :show="true" />
  </div>
</template>
<script>
import XnWaiting from '../components/primitives/XnWaiting.vue'
export default {
  name: 'CheckoutSuccess',

  components: { XnWaiting },
  props: {
    id: { type: String, default: null },
  },
  data () {
    return {}
  },
  mounted () {
    let self = this
    this.$api.Transactions.checkoutSuccess(this.id)
      .then(res => {
        if (res.status === 201) {
          self.$router.push({ path: '/order/success/'+res.data.id_val })
        } else {
          alert('Something went wrong! ' + res.message)
        }
      })
      .catch(err => {
        alert(err.message)
      })
  },
}
</script>
<style lang="postcss" scoped></style>
